import {
  createContext,
  FC,
  ReactNode,
  useContext,
  useEffect,
  useReducer,
} from "react";
import { SplashScreen } from "src/components/splash-screen";
import { WhiteLabelConfig } from "src/types/snugtotal";

const axios = require("axios").default;

interface WhiteLabelConfigProviderProps {
  children: ReactNode;
}

type WhiteLabelConfigStoreAction = {
  type: "SET_WHITE_LABEL_CONFIG";
  payload: WhiteLabelConfig;
};

const whiteLabelConfigReducer = (
  state: WhiteLabelConfig,
  action: WhiteLabelConfigStoreAction
): WhiteLabelConfig => {
  switch (action.type) {
    case "SET_WHITE_LABEL_CONFIG":
      return {
        ...state,
        ...action.payload,
        wl_professional_group: action.payload.professional_group,
      };
    default:
      return state;
  }
};

const WhiteLabelConfigContext = createContext<WhiteLabelConfig>({
  domain: "",
  disclaimer: null,
  professional_group: null,
  allow_signup: false,
  wl_professional_group: null,
  dashboard_domain: "",
  product_name: "",
  email_sender: "",
});

export const WhiteLabelConfigProvider: FC<WhiteLabelConfigProviderProps> = (
  props
) => {
  const { children } = props;
  const [state, dispatch] = useReducer(whiteLabelConfigReducer, {
    domain: "",
    disclaimer: null,
    professional_group: null,
    allow_signup: false,
    wl_professional_group: null,
    dashboard_domain: "",
    product_name: "",
    email_sender: "",
  });

  useEffect(() => {
    const getWhiteLabelConfig = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_SNUG_API_URL + "/v3/white-label-config/"
        );
        dispatch({
          type: "SET_WHITE_LABEL_CONFIG",
          payload: response.data.data,
        });
      } catch (error) {
        console.error(error);
      }
    };
    getWhiteLabelConfig();
  }, []);

  if (!state.dashboard_domain) {
    return <SplashScreen />;
  }

  return (
    <WhiteLabelConfigContext.Provider
      value={{
        domain: state.domain,
        disclaimer: "This is a sample disclaimer.",
        professional_group: null, //don't uset this one for clarity downstream.
        allow_signup: state?.allow_signup,
        wl_professional_group: state?.professional_group,
        dashboard_domain: state.dashboard_domain,
        product_name: state.product_name,
        email_sender: state.email_sender,
      }}
    >
      {children}
    </WhiteLabelConfigContext.Provider>
  );
};

export default function useWhiteLabelConfig() {
  return useContext(WhiteLabelConfigContext);
}

export const WhiteLabelConfigConsumer = WhiteLabelConfigContext.Consumer;
